import {RequestsWaterfall} from "@/components/transaction/RequestsWaterfall.tsx";
import {NetworkStep} from "@/pages/pagespeed/types.ts";

interface WaterfallTabProps {
  network: NetworkStep[];
}
export const WaterfallTab = ({network}: WaterfallTabProps) => {
  return (
    <div className="mt-3">
      <h5>Requests waterfall</h5>
      <div className="mt-3">
        <RequestsWaterfall requests={network} />
      </div>
    </div>
  );
};
